function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable no-undef */

/* eslint-disable no-alert */

/* eslint-disable no-unused-expressions */
import Vue from 'vue';
import Dropzone from 'dropzone'; //eslint-disable-line

import awsEndpoint from './urlsigner';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
Dropzone.autoDiscover = false;

var FileUpload = /*#__PURE__*/function () {
  function FileUpload() {
    _classCallCheck(this, FileUpload);
  }

  _createClass(FileUpload, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-file-upload', {
        template: "\n        <div :id=\"id\" ref=\"dropzoneElement\" :class=\"{ 'vue-dropzone dropzone file-upload': includeStyling }\">\n          <div v-if=\"useCustomSlot\" class=\"dz-message\">\n            <button class=\"dz-button\" type=\"button\"><i class=\"plus\"></i> <slot>click or drag your photos in this area</slot></button>\n          </div>\n          <div class=\"dz-preview dz-add-more\"></div>\n        </div>",
        props: {
          value: {
            required: false
          },
          id: {
            type: String,
            "default": 'dropzone'
          },
          acceptedFiles: {
            type: String,
            "default": 'image/*'
          },
          // options: {
          //   type: Object,
          //   required: true
          // },
          includeStyling: {
            type: Boolean,
            "default": true,
            required: false
          },
          awss3: {
            type: Object,
            required: false,
            "default": null
          },
          destroyDropzone: {
            type: Boolean,
            "default": true,
            required: false
          },
          duplicateCheck: {
            type: Boolean,
            "default": false,
            required: false
          },
          useCustomSlot: {
            type: Boolean,
            "default": true,
            required: false
          }
        },
        data: function data() {
          return {
            options: {
              url: '/',
              thumbnailWidth: 130,
              thumbnailHeight: 130,
              addRemoveLinks: true,
              autoProcessQueue: false,
              maxFilesize: 15,
              dictDefaultMessage: "<i class='plus'></i> click or drag your photos in this area",
              previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n                  <div class=\"dz-image\"><img data-dz-thumbnail /></div>\n                  <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n                  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n                  <div class=\"dz-success-mark\"><i class=\"check\"></i></div>\n                  <div class=\"dz-error-mark\"><i class=\"close\"></i></div>\n                  <div class=\"dz-remove\" data-dz-remove><i class=\"close\"></i></div>\n              </div>\n          "
            },
            isS3: false,
            isS3OverridesServerPropagation: false,
            wasQueueAutoProcess: true
          };
        },
        computed: {
          dropzoneSettings: function dropzoneSettings() {
            var defaultValues = _objectSpread({
              thumbnailWidth: 200,
              thumbnailHeight: 200,
              acceptedFiles: this.acceptedFiles
            }, this.options); // Object.keys(this.options).forEach(function (key) {
            //   defaultValues[key] = this.options[key];
            // }, this);


            if (this.awss3 !== null) {
              defaultValues.autoProcessQueue = false;
              this.isS3 = true; //eslint-disable-line

              this.isS3OverridesServerPropagation = this.awss3.sendFileToServer === false; //eslint-disable-line

              if (this.options.autoProcessQueue !== undefined) {
                this.wasQueueAutoProcess = this.options.autoProcessQueue;
              } //eslint-disable-line


              if (this.isS3OverridesServerPropagation) {
                defaultValues.url = function (files) {
                  return files[0].s3Url;
                };
              }
            }

            return defaultValues;
          }
        },
        mounted: function mounted() {
          if (this.$isServer && this.hasBeenMounted) {
            return;
          }

          this.hasBeenMounted = true;
          this.dropzone = new Dropzone(this.$refs.dropzoneElement, this.dropzoneSettings);
          var vm = this;
          this.dropzone.on('thumbnail', function (file, dataUrl) {
            vm.$emit('vdropzone-thumbnail', file, dataUrl);
          });
          this.dropzone.on('addedfile', function (file) {
            // let isDuplicate = false;
            if (vm.duplicateCheck) {
              if (this.files.length) {
                var _i;

                var _len;

                for (_i = 0, _len = this.files.length; _i < _len - 1; _i++ // -1 to exclude current file
                ) {
                  if (this.files[_i].name === file.name && this.files[_i].size === file.size && this.files[_i].lastModifiedDate.toString() === file.lastModifiedDate.toString()) {
                    this.removeFile(file);
                    isDuplicate = true;
                    vm.$emit('vdropzone-duplicate-file', file);
                  }
                }
              }
            }

            vm.$emit('vdropzone-file-added', file);
            vm.$emit('input', vm.dropzone.files);
            vm.setThumbnailsClass();

            if (vm.isS3 && vm.wasQueueAutoProcess && !file.manuallyAdded) {
              vm.getSignedAndUploadToS3(file);
            }
          });
          this.dropzone.on('addedfiles', function (files) {
            vm.$emit('vdropzone-files-added', files);
            vm.$emit('input', vm.dropzone.files);
          });
          this.dropzone.on('removedfile', function (file) {
            vm.$emit('vdropzone-removed-file', file);
            vm.$emit('input', vm.dropzone.files);

            if (file.manuallyAdded && vm.dropzone.options.maxFiles !== null) {
              vm.dropzone.options.maxFiles++;
            }
          });
          this.dropzone.on('success', function (file, response) {
            vm.$emit('vdropzone-success', file, response);

            if (vm.isS3) {
              if (vm.isS3OverridesServerPropagation) {
                var xmlResponse = new window.DOMParser().parseFromString(response, 'text/xml');
                var s3ObjectLocation = xmlResponse.firstChild.children[0].innerHTML;
                vm.$emit('vdropzone-s3-upload-success', s3ObjectLocation);
              }

              if (vm.wasQueueAutoProcess) vm.setOption('autoProcessQueue', false);
            }
          });
          this.dropzone.on('successmultiple', function (file, response) {
            vm.$emit('vdropzone-success-multiple', file, response);
          });
          this.dropzone.on('error', function (file, message, xhr) {
            vm.$emit('vdropzone-error', file, message, xhr);
            if (this.isS3) vm.$emit('vdropzone-s3-upload-error');
          });
          this.dropzone.on('errormultiple', function (files, message, xhr) {
            vm.$emit('vdropzone-error-multiple', files, message, xhr);
          });
          this.dropzone.on('sending', function (file, xhr, formData) {
            if (vm.isS3) {
              if (vm.isS3OverridesServerPropagation) {
                var signature = file.s3Signature;
                Object.keys(signature).forEach(function (key) {
                  formData.append(key, signature[key]);
                });
              } else {
                formData.append('s3ObjectLocation', file.s3ObjectLocation);
              }
            }

            vm.$emit('vdropzone-sending', file, xhr, formData);
          });
          this.dropzone.on('sendingmultiple', function (file, xhr, formData) {
            vm.$emit('vdropzone-sending-multiple', file, xhr, formData);
          });
          this.dropzone.on('complete', function (file) {
            vm.$emit('vdropzone-complete', file);
          });
          this.dropzone.on('completemultiple', function (files) {
            vm.$emit('vdropzone-complete-multiple', files);
          });
          this.dropzone.on('canceled', function (file) {
            vm.$emit('vdropzone-canceled', file);
          });
          this.dropzone.on('canceledmultiple', function (files) {
            vm.$emit('vdropzone-canceled-multiple', files);
          });
          this.dropzone.on('maxfilesreached', function (files) {
            vm.$emit('vdropzone-max-files-reached', files);
          });
          this.dropzone.on('maxfilesexceeded', function (file) {
            vm.$emit('vdropzone-max-files-exceeded', file);
          });
          this.dropzone.on('processing', function (file) {
            vm.$emit('vdropzone-processing', file);
          });
          this.dropzone.on('processingmultiple', function (files) {
            vm.$emit('vdropzone-processing-multiple', files);
          });
          this.dropzone.on('uploadprogress', function (file, progress, bytesSent) {
            vm.$emit('vdropzone-upload-progress', file, progress, bytesSent);
          });
          this.dropzone.on('totaluploadprogress', function (totaluploadprogress, totalBytes, totalBytesSent) {
            vm.$emit('vdropzone-total-upload-progress', totaluploadprogress, totalBytes, totalBytesSent);
          });
          this.dropzone.on('reset', function () {
            vm.$emit('vdropzone-reset');
          });
          this.dropzone.on('queuecomplete', function () {
            vm.$emit('vdropzone-queue-complete');
          });
          this.dropzone.on('drop', function (event) {
            vm.$emit('vdropzone-drop', event);
          });
          this.dropzone.on('dragstart', function (event) {
            vm.$emit('vdropzone-drag-start', event);
          });
          this.dropzone.on('dragend', function (event) {
            vm.$emit('vdropzone-drag-end', event);
          });
          this.dropzone.on('dragenter', function (event) {
            vm.$emit('vdropzone-drag-enter', event);
          });
          this.dropzone.on('dragover', function (event) {
            vm.$emit('vdropzone-drag-over', event);
          });
          this.dropzone.on('dragleave', function (event) {
            vm.$emit('vdropzone-drag-leave', event);
          });
          vm.$emit('vdropzone-mounted');
        },
        beforeDestroy: function beforeDestroy() {
          if (this.destroyDropzone) this.dropzone.destroy();
        },
        methods: {
          setThumbnailsClass: function setThumbnailsClass() {
            var _this = this;

            _toConsumableArray(this.$el.querySelectorAll('.dz-file-preview')).forEach(function (file, index) {
              console.log(file, _this.dropzone.files[index]);
              file.classList.add(_this.dropzone.files[index].type.replace('/', '-'));
            });
          },
          manuallyAddFile: function manuallyAddFile(file, fileUrl) {
            console.log('manuallyAddFile', file, fileUrl);
            file.manuallyAdded = true;
            this.dropzone.emit('addedfile', file);
            var containsImageFileType = false;

            if (fileUrl.indexOf('.svg') > -1 || fileUrl.indexOf('.png') > -1 || fileUrl.indexOf('.jpg') > -1 || fileUrl.indexOf('.jpeg') > -1 || fileUrl.indexOf('.gif') > -1 || fileUrl.indexOf('.webp') > -1) {
              containsImageFileType = true;
            }

            if (this.dropzone.options.createImageThumbnails && containsImageFileType && file.size <= this.dropzone.options.maxThumbnailFilesize * 1024 * 1024) {
              fileUrl && this.dropzone.emit('thumbnail', file, fileUrl);
              var thumbnails = file.previewElement.querySelectorAll('[data-dz-thumbnail]');

              for (var i = 0; i < thumbnails.length; i++) {
                thumbnails[i].style.width = "".concat(this.dropzoneSettings.thumbnailWidth, "px");
                thumbnails[i].style.height = "".concat(this.dropzoneSettings.thumbnailHeight, "px");
                thumbnails[i].style['object-fit'] = 'contain';
              }
            }

            this.dropzone.emit('complete', file);
            if (this.dropzone.options.maxFiles) this.dropzone.options.maxFiles--;
            this.dropzone.files.push(file);
            this.$emit('vdropzone-file-added-manually', file);
          },
          setOption: function setOption(option, value) {
            this.dropzone.options[option] = value;
          },
          removeAllFiles: function removeAllFiles(bool) {
            this.dropzone.removeAllFiles(bool);
          },
          processQueue: function processQueue() {
            var _this2 = this;

            var dropzoneEle = this.dropzone;

            if (this.isS3 && !this.wasQueueAutoProcess) {
              this.getQueuedFiles().forEach(function (file) {
                _this2.getSignedAndUploadToS3(file);
              });
            } else {
              this.dropzone.processQueue();
            }

            this.dropzone.on('success', function () {
              dropzoneEle.options.autoProcessQueue = true;
            });
            this.dropzone.on('queuecomplete', function () {
              dropzoneEle.options.autoProcessQueue = false;
            });
          },
          init: function init() {
            return this.dropzone.init();
          },
          destroy: function destroy() {
            return this.dropzone.destroy();
          },
          updateTotalUploadProgress: function updateTotalUploadProgress() {
            return this.dropzone.updateTotalUploadProgress();
          },
          getFallbackForm: function getFallbackForm() {
            return this.dropzone.getFallbackForm();
          },
          getExistingFallback: function getExistingFallback() {
            return this.dropzone.getExistingFallback();
          },
          setupEventListeners: function setupEventListeners() {
            return this.dropzone.setupEventListeners();
          },
          removeEventListeners: function removeEventListeners() {
            return this.dropzone.removeEventListeners();
          },
          disable: function disable() {
            return this.dropzone.disable();
          },
          enable: function enable() {
            return this.dropzone.enable();
          },
          filesize: function filesize(size) {
            return this.dropzone.filesize(size);
          },
          accept: function accept(file, done) {
            return this.dropzone.accept(file, done);
          },
          addFile: function addFile(file) {
            return this.dropzone.addFile(file);
          },
          removeFile: function removeFile(file) {
            this.dropzone.removeFile(file);
          },
          getAcceptedFiles: function getAcceptedFiles() {
            return this.dropzone.getAcceptedFiles();
          },
          getRejectedFiles: function getRejectedFiles() {
            return this.dropzone.getRejectedFiles();
          },
          getFilesWithStatus: function getFilesWithStatus() {
            return this.dropzone.getFilesWithStatus();
          },
          getQueuedFiles: function getQueuedFiles() {
            return this.dropzone.getQueuedFiles();
          },
          getUploadingFiles: function getUploadingFiles() {
            return this.dropzone.getUploadingFiles();
          },
          getAddedFiles: function getAddedFiles() {
            return this.dropzone.getAddedFiles();
          },
          getActiveFiles: function getActiveFiles() {
            return this.dropzone.getActiveFiles();
          },
          getSignedAndUploadToS3: function getSignedAndUploadToS3(file) {
            var _this3 = this;

            var promise = awsEndpoint.sendFile(file, this.awss3, this.isS3OverridesServerPropagation);

            if (!this.isS3OverridesServerPropagation) {
              promise.then(function (response) {
                if (response.success) {
                  file.s3ObjectLocation = response.message;
                  setTimeout(function () {
                    return _this3.dropzone.processFile(file);
                  });

                  _this3.$emit('vdropzone-s3-upload-success', response.message);
                } else if (typeof response.message !== 'undefined') {
                  _this3.$emit('vdropzone-s3-upload-error', response.message);
                } else {
                  _this3.$emit('vdropzone-s3-upload-error', 'Network Error : Could not send request to AWS. (Maybe CORS error)');
                }
              });
            } else {
              promise.then(function () {
                setTimeout(function () {
                  return _this3.dropzone.processFile(file);
                });
              });
            }

            promise["catch"](function (error) {
              alert(error);
            });
          },
          setAWSSigningURL: function setAWSSigningURL(location) {
            if (this.isS3) {
              this.awss3.signingURL = location;
            }
          }
        }
      });
    }
  }]);

  return FileUpload;
}();

export default FileUpload;